import { generateUUID } from 'common/utils/utils';

export default function defaultEmailAddress(isPrimary = false) {
  return {
    id: generateUUID(),
    email_address: '',
    acceptable_communication_types: {},
    is_primary: isPrimary,
  };
}
